import { environment } from "src/environments/environment";
import { CookiesConsentService } from '@ildes/services/cookies-consent.service';
import { StorageService } from "./services/storage-service.service";
import { UserStorageService } from "./services/user-storage-service.service";
import { NativeLayerService } from "./services/native-layer.service";

export const initStorage = (
    native: NativeLayerService,
    storageService: StorageService,
    userStorageService: UserStorageService) => {
    return async () => {
        if (native.isNative) {
            await storageService.initFromPreferences();
            await userStorageService.initFromPreferences();
        }
    }
}
    